module.exports = __webpack_public_path__ + "img/take-off.ec2b9925.svg";